module.exports = __webpack_public_path__ + "static/media/HOW CAN I ATTACH DOCUMENTS WITH THE EMAILS.934d1a4f.png";